<script lang="ts" setup>
defineProps<{ basketLineCount: string | number }>();
</script>

<template>
  <UChip
    :text="basketLineCount"
    color="primary"
    :ui="{ base: 'top-2 right-2 p-1! size-5 text-xs leading-6' }"
    size="3xl"
    data-test="mini-basket-count"
  >
    <UButton
      variant="solid" :ui="{ base: 'bg-neutral-50 hover:shadow-lg text-primary size-12.5 hover:bg-neutral-50' }"
      :to="$localePath(`/checkout`)"
    >
      <UIcon name="i-ph-shopping-cart-simple" class="text-primary text-xl" />
    </UButton>
  </UChip>
</template>

<style scoped>

</style>
